import React, { cloneElement } from "react";
import type { FieldProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import {
  FieldPathProvider,
  useFieldPath,
} from "../../../FieldPathContext/FieldPathContext";
import {
  isFieldSelected,
  useSubmissionsBuilderContext,
} from "../../../SubmissionsBuilderContext";
import { withStopPropagation } from "../../../utils";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

type BaseFieldPreviewProps = FieldProps & {
  children: React.JSX.Element;
};

function WrappedBaseFieldPreview({ children }: BaseFieldPreviewProps) {
  const { selectField, selectedField } = useSubmissionsBuilderContext();
  const { pathArray } = useFieldPath();

  const isSelected = isFieldSelected(pathArray, selectedField);

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(() => {
        selectField(pathArray);
      })}
      isSelected={isSelected}
    >
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
    </BuilderFieldWrapper>
  );
}

export function BaseFieldPreview(props: BaseFieldPreviewProps) {
  return (
    <FieldPathProvider path={props.name}>
      <WrappedBaseFieldPreview {...props} />
    </FieldPathProvider>
  );
}
